import RegisterPartnerJsSerializer from './-json-api';

export default class PartnerRegistrationSerializer extends RegisterPartnerJsSerializer {
  modelNameFromPayloadKey(key) {
    if (key === 'organizations') {
      return 'register-organization';
    }

    if (key === 'partner_registrations') {
      return 'partner-registration';
    }
    return key;
  }

  keyForRelationship(key) {
    return key;
  }
}
